import { Buffer } from 'buffer';
import { randomBytes } from 'crypto';

/**
 * Generates a uuid4
 */
export default function generateUUID() {
    const bytes = randomBytes(16);

    // Buffer.from ignores offset/length for Uint8Array inputs (they only apply to ArrayBuffer),
    // so this has always been a full copy; the args are dropped to match the real overload.
    const timeBuf = Buffer.from(bytes);
    let timeHiAndVersion, clockHiAndVersion;

    if (timeBuf && timeBuf.length > 1) {
        const timeHi = timeBuf[1].toString();
        timeHiAndVersion = Number(Buffer.from(timeHi));
    }

    const clockBuf = Buffer.from(bytes);

    if (clockBuf && clockBuf.length > 1) {
        const clockHi = clockBuf[1].toString();
        clockHiAndVersion = Number(Buffer.from(clockHi));
    }

    if (timeHiAndVersion) {
        bytes[6] = timeHiAndVersion;
    }

    if (clockHiAndVersion) {
        bytes[8] = clockHiAndVersion;
    }

    const hexString = bytes.toString('hex');
    return `${hexString.substring(0, 8)}-${hexString.substring(8, 12)}-${hexString.substring(
        12,
        16,
    )}-${hexString.substring(16, 20)}-${hexString.substring(20, 32)}`;
}
